import { Routes, Route, Navigate } from 'react-router-dom';
import PageUnderConstruction from './pages/underConstruction/index';
import PageChart from './pages/plotlySection/index';
import HomePage from './pages/home/index'
import LoginPage from './pages/login/index'
import WelcomePage from './pages/landing/index'
import ContactPage from "./pages/contact";
import AboutPage from "./pages/about";
import OuroPretoPage from "./pages/ouropreto/index";
import ErrorPage from "./pages/error/errorPage";
import PageMembers from "./pages/members";
import PrivateRoute from '../src/components/privateRoute';
import PageEditProfile from './pages/editProfile/index';
import PageDocuments from './pages/documents/index';
import MembersPublic from './pages/membersPublic';




const RoutesApp = () => (
    <Routes>
        <Route path="/fundChart" element={<PrivateRoute><PageChart /></PrivateRoute>} />
        <Route path="/home" element={<PrivateRoute><HomePage /></PrivateRoute>} />
        <Route path="/members" element={<PrivateRoute><PageMembers /></PrivateRoute>} />
        <Route path="/documents" element={<PrivateRoute><PageDocuments /></PrivateRoute>} />
        <Route path="/editProfile" element={<PrivateRoute><PageEditProfile /></PrivateRoute>} />


        {/* Rota pública */}
        <Route path="/underConstruction" element={<PageUnderConstruction />} />

        {/* WelcomePage */}
        <Route path="/welcome" element={<WelcomePage />} />

        {/* Perdidos */}
        <Route path="/perdidos" element={<MembersPublic />} />

        {/* Rota pública */}
        <Route path="/login" element={<LoginPage />} />

        {/* Rota pública */}
        <Route path="/about" element={<AboutPage />} />

        {/* Rota pública */}
        <Route path="/ouropreto" element={<OuroPretoPage />} />

        {/* Rota pública */}
        <Route path="/contact" element={<ContactPage />} />

        {/* Rota genérica */}
        <Route path="/" element={<Navigate to="/welcome" replace />} />

        <Route path="/404" element={<ErrorPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />

    </Routes>
);

export default RoutesApp;